"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslation = exports.setLocale = void 0;
var tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/camelcase */
var react_1 = require("react");
var zh_CN_1 = tslib_1.__importDefault(require("./locale/zh_CN"));
var en_US_1 = tslib_1.__importDefault(require("./locale/en_US"));
var config_context_1 = require("../_util/config-context");
var translationMap_1 = require("./translationMap");
// 约定中语言名不规范
var lngs = {
    zh: "zh_CN",
    en: "en_US",
    jp: "ja_JP",
    ko: "ko_KR",
};
function setLocale() {
    console.error("`setLocale()` 方法已废弃");
}
exports.setLocale = setLocale;
function useTranslation(moment) {
    var configLocale = config_context_1.useConfig().locale;
    var t = typeof configLocale === "string"
        ? translationMap_1.translationMap[configLocale] || zh_CN_1.default
        : tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, zh_CN_1.default), en_US_1.default), configLocale);
    var locale = lngs[t.locale] || t.locale;
    react_1.useState(function () {
        if (moment) {
            moment.locale(locale);
        }
    });
    react_1.useEffect(function () {
        if (moment) {
            moment.locale(locale);
        }
    }, [locale]); // eslint-disable-line react-hooks/exhaustive-deps
    return t;
}
exports.useTranslation = useTranslation;
/* eslint-enable @typescript-eslint/camelcase */
//# sourceMappingURL=translation.js.map